angular.module('employerAgreementModule', ['cacheManagerModule'])
    .service('employerAgreementService', ['$q', 'cacheManagerService', employerAgreementService])
    .controller('employerAgreementController', ['$q', '$scope', '$http', 'employerAgreementService', employerAgreementController]);